<template>
</template>

<script>
export default {
    props: ['offer_id'],
    data() {
        return {
            ip: null,
        }
    },
    methods: {
        addOpenOffer() {
            axios.post("/api/offerOpens/"+this.offer_id,{
                'offer_id': this.offer_id,
                'ip': this.ip
            }).then(response=>{
                if(response.data === "email_sent"){
                }
            });
        }
    },
    created () {
       fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
            this.ip = ip;
        });
    },
    watch: {
        ip: function(){
            if(this.ip != null){
                this.addOpenOffer()
            }
        }
    },

}
</script>

<style lang="scss" scoped>

</style>